import styled from 'styled-components'

import { helpers } from '../../../../styles/theme'

type Props = {
	isVisible: boolean
	hasFocus: boolean
}

export const Container = styled.div<Props>`
	display: flex;
	align-items: center;
	column-gap: 4px;
	background-color: ${helpers.color.input.errorBoxBackground};
	height: ${({ isVisible }) => (isVisible ? '33px' : 0)};
	padding: ${({ isVisible }) => (isVisible ? '12px 8px 8px' : '0px 8px')};
	visibility: ${({ isVisible }) => (isVisible ? 'visible' : 'hidden')};
	transition: height 135ms ease, box-shadow 135ms ease, padding 135ms ease;
	width: 100%;
	border-radius: 4px;
	box-shadow: ${({ isVisible, hasFocus }) => (isVisible && hasFocus ? `0 0 0 2px ${helpers.color.input.errorBoxBackground}` : 'none')};
	overflow: hidden;
	text-align: left;
	color: ${helpers.color.input.errorBox};
	font-size: 12px;
	line-height: 14px;
`
